import React from 'react'
import { Box, InputLabel, Stack, SxProps, TextField, Tooltip, Typography } from '@mui/material'
import { Info } from 'react-feather'
import { Trans, useTranslation } from 'react-i18next'
import { inputLabelContainerStyle, inputLabelStyle, labelTooltipContainerStyle } from './InputTextField.styles'

type InputTextFieldProps = {
	i18nLabel: string
	i18nTooltip?: string
	i18nPlaceholder?: string
	name: string
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
	value: string
	required?: boolean
	sx?: SxProps
	type?: string
	error?: { value: boolean; message?: string }
	inputComponent?: any
	disabled?: boolean
	InputProps?: any
}

export default function InputTextField({
	i18nLabel,
	i18nTooltip,
	name,
	onChange,
	onFocus,
	value,
	required,
	sx,
	inputComponent,
	error = { value: false },
	type = 'text',
	i18nPlaceholder = '',
	disabled = false,
	InputProps = {},
}: InputTextFieldProps) {
	const { t } = useTranslation()
	return (
		<Stack sx={sx}>
			<Box sx={labelTooltipContainerStyle}>
				<InputLabel shrink={false} htmlFor={name} required={required} sx={inputLabelContainerStyle}>
					<Typography sx={inputLabelStyle} variant="h5" component="span">
						<Trans i18nKey={i18nLabel} />
					</Typography>
				</InputLabel>
				{i18nTooltip && (
					<Tooltip arrow placement="top" title={t(i18nTooltip)} sx={{ display: 'inline' }}>
						<Info style={{ width: '20px', height: '20px' }} />
					</Tooltip>
				)}
			</Box>
			<TextField
				disabled={disabled}
				helperText={error?.message}
				error={error?.value}
				name={name}
				type={type}
				placeholder={t(i18nPlaceholder)}
				value={value}
				variant="outlined"
				InputProps={{ ...InputProps, inputComponent, style: { fontSize: '14px' } }}
				onChange={onChange}
				onFocus={onFocus}
				fullWidth
			/>
		</Stack>
	)
}
